import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {Emitter, OldEmitterConfig, AnimatedParticle} from "pixi-particles";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {FireInTheHole2} from "../FireInTheHole2";
import {TweenLite} from "gsap";

export class CoinRain extends PIXI.Container implements StageLayer {

    private _defaultConfig: OldEmitterConfig =
        {
            "alpha":{
                "start":1,
                "end":0.4
            },
            "scale":{
                "start":0.7,
                "end":0.1,
                "minimumScaleMultiplier":1
            },
            "color":{
                "start":"#ffffff",
                "end":"#ffffff"
            },
            "speed":{
                "start":10,
                "end":20,
                "minimumSpeedMultiplier":1
            },
            "acceleration":{
                "x":0,
                "y":-50
            },
            "maxSpeed":280,
            "startRotation":{
                "min": 0,
                "max": 0
            },
            "noRotation":false,
            "rotationSpeed":{
                "min":5,
                "max":5
            },
            "lifetime":{
                "min":2,
                "max":4
            },
            "autoUpdate": true,
            "blendMode":"add",
            "frequency":0.1,
            "emitterLifetime":-1,
            "maxParticles":200,
            "pos":{
                "x":0,
                "y":0
            },
            "addAtBack":false,
            "spawnType":"rect",
            "spawnRect":{
                "x":-840,
                "y":0,
                "w":1680,
                "h":1
            }
        };
    private _goldRainConfig: OldEmitterConfig =
        {
            "alpha":{
                "start":1,
                "end":1
            },
            "scale":{
                "start":0.2,
                "end":0.4,
                "minimumScaleMultiplier":3
            },
            "color":{
                "start":"#ffffff",
                "end":"#ffffff"
            },
            "speed":{
                "start":0,
                "end":400,
                "minimumSpeedMultiplier":6
            },
            "acceleration":{
                "x":0,
                "y":400
            },
            "maxSpeed":400,
            "startRotation":{
                "min": 235,
                "max": 310
            },
            "noRotation":false,
            "rotationSpeed":{
                "min":20,
                "max":40
            },
            "lifetime":{
                "min":3,
                "max":6
            },
            "autoUpdate": true,
            "blendMode":"normal",
            "frequency":0.005,
            "emitterLifetime":-1,
            "maxParticles":800,
            "pos":{
                "x":0,
                "y":0
            },
            "addAtBack":false,
            "spawnType":"rect",
            "spawnRect":{
                "x":-840,
                "y":-30,
                "w":1680,
                "h":1
            }
        };

    private _particleContainer: PIXI.Container;
    private _goldRainContainer: PIXI.Container;
    private _bigWinEmitters: Emitter[] = [];
    private _goldRainEmitter: Emitter;

    constructor() {
        super();
        this.name = "CoinRain"
        this.init();
    }

    private init() {
        this._particleContainer = new PIXI.Container();
        this._particleContainer.position.set(360, 0);
        this._particleContainer.name = "particleContainer";
        this._goldRainContainer = new PIXI.Container();
        this._goldRainContainer.position.set(360, 0);
        this._goldRainContainer.name = "goldRainContainer";
        this.addChild(this._particleContainer,this._goldRainContainer);

        for (let i: number = 0; i < 5; i++) {
            this._bigWinEmitters.push(new Emitter(this._particleContainer, FireInTheHole2.assetLoader.getTextures(`BigWin/fireParticles/fire${i>3?4:(i + 1)}`), this._defaultConfig));
        }
        this._goldRainEmitter = new Emitter(this._goldRainContainer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : FireInTheHole2.assetLoader.getTextures(`BigWin/gold/gold_000`)
        }], this._goldRainConfig);
        this._goldRainEmitter.particleConstructor = AnimatedParticle;
        this.stopAll();
    }

    public onResize() {
        this._particleContainer.position.set(360, NolimitApplication.screenBounds.bottom);
        this._goldRainContainer.position.set(360, NolimitApplication.screenBounds.top);
    }

    public startBigWinRain(level: number) {
        this._bigWinEmitters[level - 1].emit = true;
        if(level === 5){
            this._goldRainContainer.alpha = 1;
            this._goldRainEmitter.emit = true;
        }
    }


    public stop(level: number) {
        this._bigWinEmitters[level].emit = false;
    }

    public hide(duration:number):TweenLite{
        return TweenLite.to(this._goldRainContainer, duration, {alpha:0});
    }

    public stopAll() {
        for (let emitter of this._bigWinEmitters) {
            emitter.emit = false;
        }
        this._goldRainEmitter.emit = false;
    }
}